import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import Navigation from '../components/Navigation';
import { toast } from 'react-toastify';

function ApplyLoan() {
  const [eligibility, setEligibility] = useState(null);
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [eligRes, loansRes] = await Promise.all([
        api.get('/Loan/eligibility'),
        api.get('/Loan/my-loans'),
      ]);
      setEligibility(eligRes.data);
      setLoans(loansRes.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const handleApply = async () => {
    setLoading(true);
    try {
      const res = await api.post('/Loan/apply');
      toast.success(res.data.message || 'Loan applied successfully!');
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to apply loan');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 pb-20">
      <div className="bg-purple-600 text-white p-4">
        <button onClick={() => navigate(-1)} className="text-sm mb-2">← Back</button>
        <h2 className="text-xl font-bold">Super Power Loan</h2>
        <p className="text-purple-200 text-sm">₹5,00,000</p>
      </div>

      <div className="p-4 space-y-4">
        {/* Eligibility Card */}
        {eligibility && (
          <div className="bg-white rounded-2xl p-4 shadow">
            <h3 className="font-semibold text-gray-700 mb-3">Eligibility Status</h3>

            <div className={`p-3 rounded-xl mb-3 ${eligibility.isEligible ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-600'}`}>
              <p className="font-bold">
                {eligibility.isEligible ? '✅ You are Eligible!' : '❌ Not Eligible yet'}
              </p>
              <p className="text-sm mt-1">{eligibility.message}</p>
            </div>

            <div className="grid grid-cols-2 gap-3 text-sm">
              <div className="bg-gray-50 p-3 rounded-xl">
                <p className="text-gray-500">Direct Members</p>
                <p className="font-bold">{eligibility.directMembers} / 2</p>
              </div>
              <div className="bg-gray-50 p-3 rounded-xl">
                <p className="text-gray-500">Sponsor Active</p>
                <p className="font-bold">{eligibility.isSponsorActive ? 'Yes' : 'No'}</p>
              </div>
              <div className="bg-gray-50 p-3 rounded-xl">
                <p className="text-gray-500">Loan Amount</p>
                <p className="font-bold">₹{eligibility.loanAmount?.toLocaleString()}</p>
              </div>
              <div className="bg-gray-50 p-3 rounded-xl">
                <p className="text-gray-500">EMI / Month</p>
                <p className="font-bold">₹{eligibility.emiAmount?.toLocaleString()}</p>
              </div>
            </div>

            {eligibility.isEligible && (
              <button
                onClick={handleApply}
                disabled={loading}
                className="w-full mt-4 bg-purple-600 text-white font-bold py-3 rounded-xl disabled:opacity-50"
              >
                {loading ? 'Applying...' : 'Apply for Loan'}
              </button>
            )}
          </div>
        )}

        {/* My Loans */}
        <div>
          <h3 className="font-semibold text-gray-700 mb-3">My Loan Applications</h3>

          {loans.length === 0 ? (
            <p className="text-center text-gray-400 py-6 bg-white rounded-2xl">No loan applied yet</p>
          ) : (
            <div className="space-y-3">
              {loans.map((loan) => (
                <div key={loan.id} className="bg-white rounded-2xl p-4 shadow">
                  <div className="flex justify-between items-center mb-2">
                    <p className="font-bold text-lg">₹{loan.amount?.toLocaleString()}</p>
                    <span className={`text-xs px-2 py-1 rounded-full ${
                      loan.status === 'Pending' ? 'bg-yellow-100 text-yellow-700' :
                      loan.status === 'Approved' ? 'bg-green-100 text-green-700' :
                      'bg-gray-100 text-gray-600'
                    }`}>
                      {loan.status}
                    </span>
                  </div>
                  <p className="text-sm text-gray-500">
                    Applied: {new Date(loan.appliedAt).toLocaleDateString()}
                  </p>
                  <p className="text-sm text-gray-500">
                    EMIs: {loan.paidEMIs}/{loan.totalEMIs} paid
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <Navigation />
    </div>
  );
}

export default ApplyLoan;